import { IMAGES, Reveal } from "@/components/site/shared";

export default function Travel() {
  return (
    <div>
      <section className="pt-32 md:pt-40 pb-12 max-w-7xl mx-auto px-6 md:px-8">
        <Reveal>
          <p className="overline text-orange">Travel & Hotels</p>
          <h1 className="font-display text-5xl sm:text-6xl md:text-8xl text-ink mt-4 leading-[0.95]">
            Where to stay
          </h1>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-8 pb-12">
        <Reveal>
          <div className="card-retro overflow-hidden h-[45vh] md:h-[55vh]">
            <img src={IMAGES.mantel} alt="Vintage gallery wall" className="w-full h-full object-cover object-[15%_center] lg:object-center" />
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-8 pb-24 md:pb-32">
        <Reveal>
          <div className="card-retro bg-yellow p-10 md:p-16 text-center">
            <p className="overline text-ink/70">Travel & Hotels</p>
            <h2 className="font-display text-3xl md:text-5xl text-ink mt-4">More information to come</h2>
            <p className="font-body text-ink/80 mt-4 max-w-xl mx-auto text-lg">
              We're finalizing hotel room blocks and travel details. Check back soon — everything you need
              to plan your stay will be here.
            </p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
